import { render } from "./SectionTitle.vue?vue&type=template&id=274288f2&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"

import "./SectionTitle.vue?vue&type=style&index=0&id=274288f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274288f2"]])

export default __exports__